module.exports = __webpack_public_path__ + "static/scale-model-of-cheetah-in-memphis-tennessee-58f794d63c0e139836a3abe74dd194fe.png";